export default "__VITE_ASSET__DkpcVLlj__"